
export const STATUS_FINISHED = 1
export const STATUS_PROCESSING = 2
export const STATUS_DEFAULT = 0
export const STATUS_FAILED = -1
export const STATUS_WAITING = 3
export const statusList = [
  {
    label: '完成',
    value: STATUS_FINISHED
  },
  {
    label: '失败',
    value: STATUS_FAILED
  },
  {
    label: '处理中',
    value: STATUS_PROCESSING
  },
  {
    label: '等待中',
    value: STATUS_WAITING
  },
  {
    label: 'default',
    value: STATUS_DEFAULT
  }
]
